import { readSetting, writeSetting } from '../../infrastructure/storage/localStore';

/**
 * Whether this device has been told the deck can be swiped (SPEC-025 D-18).
 *
 * The gesture is the whole of how a category is browsed and nothing on the card
 * announces it — the cards stacked underneath say "there is more of this", which
 * is not the same as "drag here". So the first plant a device opens carries a
 * hint, and no plant ever carries it again.
 *
 * ONCE PER DEVICE, which is why it cannot live in component state: the card
 * unmounts on every swipe and remounts on the next plant, so a flag in React
 * would show the hint again on every card — the exact nag it exists to avoid.
 * Same reasoning, and the same storage, as the install offer's dismissal
 * (`offerPreferences.js`).
 *
 * A preference, not data: nothing here is worth syncing and nothing here is
 * sensitive, which is what makes Web Storage the right home for it (CON-003).
 */

export const DECK_HINT_SEEN_KEY = 'plants.deckHintSeen';

export function hasSeenDeckHint() {
    return readSetting(DECK_HINT_SEEN_KEY) === 'true';
}

export function rememberDeckHintSeen() {
    return writeSetting(DECK_HINT_SEEN_KEY, 'true');
}
